var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui_slider_wrap"},[_c('VueSlider',_vm._b({staticClass:"slider_control",attrs:{"height":10,"dotStyle":{
      width: '20px',
      height: '20px',
      background: '#FFFFFF',
      border: 'solid 4px #258FFB',
      margin: '2px',
    },"railStyle":{ background: '#D9D9D9', border: 'none' },"processStyle":{ background: '#258FFB' }},on:{"change":_vm.emitValue}},'VueSlider',Object.assign({}, _vm.$attrs, _vm.$props),false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }